export default __webpack_public_path__ + "b3a70c5d22393a178b79810fac4f6395.svg";